import { Box, Button, Checkbox, Drawer, FormControl, FormControlLabel, IconButton, InputAdornment, InputBase, MenuItem, OutlinedInput, Paper, Radio, RadioGroup, Select, TextField, Typography, Chip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useState } from 'react'
import SimpleBar from 'simplebar-react';
import close from "../../../assets/svg/drawer_close.svg";
import promoCode from "../../../assets/svg/promoCode.svg";
import wallet from "../../../assets/svg/fund_wallet.svg";
import gift from "../../../assets/svg/gift.svg";
import refferalCampaign from "../../../assets/svg/refferal_campaign.svg";
import activePromoCode from "../../../assets/svg/active_promocode.svg";
import activeWallet from "../../../assets/svg/active_fund_wallet.svg";
import activeGift from "../../../assets/svg/gift_active.svg";
import activeReferral from "../../../assets/svg/active_refferal_campaign.svg";
import people from "../../../assets/svg/ellipse.svg";
import Autocomplete from '@mui/material/Autocomplete';

function AddFundDrawer({ setAddFundDrawer, addFundDrawer }) {

    const [open, setOpen] = useState(true);
    const [activeCard, setActiveCard] = useState("Promo Code");
    const [selectedEmails, setSelectedEmails] = useState([]);
  
    const handleEmailChange = (event) => {
      const {
        target: { value },
      } = event;
      setSelectedEmails(typeof value === "string" ? value.split(",") : value);
    };
  
  
    console.log(activeCard);
  
    const handleCardClick = (card) => {
      setActiveCard(card);
    };

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={() => setAddFundDrawer(!addFundDrawer)}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
        <Box sx={{ width: "560px" }}>
            <Box
            sx={{
                borderBottom: "1px solid #E5E5E8",
                paddingLeft: "20px",
                paddingTop: "20px",
                paddingBottom: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
            >
            <Typography
                sx={{
                fontSize: "24px",
                fontWeight: 600,
                }}
            >
                Add funds to Wallet
            </Typography>
            <Box
                sx={{ paddingRight: "20px", cursor: "pointer" }}
                onClick={() => setAddFundDrawer(!addFundDrawer)}
            >
                <img src={close} alt="close" />
            </Box>
            </Box>

            <SimpleBar
                forceVisible="y"
                autoHide={true}
                style={{ maxHeight: "83vh", 
                    borderBottom: "1px solid #E5E5E8"
                 }}
                className="custom-scrollbar"
            >
                <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    padding: "20px",
                    paddingBottom: "0px"
                }}
                >
                {[
                    { label: "Promo Code", icon: promoCode, activeIcon: activePromoCode },
                    { label: "Fund Wallet", icon: wallet, activeIcon: activeWallet },
                    { label: "Gift Certificate", icon: gift, activeIcon: activeGift },
                    { label: "Referral Campaign", icon: refferalCampaign, activeIcon: activeReferral },
                ].map((card, index) => (
                    <Box
                    key={index}
                    onClick={() => handleCardClick(card.label)}
                    sx={{
                        border: activeCard === card.label ? "2px solid #481AA3" : "1px solid #E5E5E8",
                        borderRadius: "8px",
                        padding: "16px",
                        textAlign: "center",
                        backgroundColor: activeCard === card.label ? "#F5F1FF" : "#F9F9F9",
                        width: "115px",
                        marginBottom: "16px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                    }}
                    >
                    <img
                        src={activeCard === card.label ? card.activeIcon : card.icon}
                        alt={card.label}
                        style={{ marginBottom: "10px" }}
                    />
                    <Typography
                        sx={{
                        color: activeCard === card.label ? "#481AA3" : "inherit",
                        }}
                    >
                        {card.label}
                    </Typography>
                    </Box>
                ))}
                </Box>
                <Box
                sx={{
                    paddingX: "20px",
                }}
                >
                <FormControlLabel
                    label="For all customers"
                    control={
                    <Checkbox
                        size="small"
                        onChange={(event) => console.log(event.target.checked)}
                    />
                    }
                />
                </Box>
                {(activeCard === "Promo Code" || activeCard === "Fund Wallet") && (
            <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Email</Typography>
              <FormControl fullWidth>
                <Autocomplete
                    multiple
                    size='small'
                    options={[
                        "muftiihid@gmail.com",
                        "hidayat.mufti@gmail.com",
                        "example1@gmail.com",
                        "example2@gmail.com"
                    ]}
                    value={selectedEmails}
                    onChange={(event, newValue) => {
                        setSelectedEmails(newValue);
                    }}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" placeholder="Select emails" />
                    )}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                        ))
                    }
                />
              </FormControl>
            </Box>
          )}
                <Box
                sx={{
                    paddingX: "20px",
                    paddingTop: "20px"
                }}
                >
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                        {
                            activeCard === "Fund Wallet" ? "Amount" : "Total discount"
                        }
                    </Typography>
                    <FormControl fullWidth>
                        <OutlinedInput
                            id="outlined-adornment-amount"
                            startAdornment={<InputAdornment position="start">%</InputAdornment>}
                        />
                    </FormControl>
                </Box>
                <Box
                sx={{
                    paddingX: "20px",
                }}
                >
                <FormControlLabel
                    label="Can only be used by assigned users(s)"
                    control={
                    <Checkbox
                        size="small"
                        onChange={(event) => console.log(event.target.checked)}
                    />
                    }
                />
                </Box>
                {
                    (activeCard === "Referral Campaign" || activeCard === "Promo Code") && (
                        <>
                        <Box
                            sx={{
                                paddingX: "20px",
                                paddingTop: "10px"
                            }}
                        >
                            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Max. amount</Typography>
                            <FormControl fullWidth>
                                <OutlinedInput
                                    id="outlined-adornment-amount"
                                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                        <Box
                        sx={{
                            paddingX: "20px",
                        }}
                        >
                        <FormControlLabel
                            label="Can only be used by assigned users(s)"
                            control={
                            <Checkbox
                                size="small"
                                onChange={(event) => console.log(event.target.checked)}
                            />
                            }
                        />
                        </Box>
                        <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
                    <label style={{ fontSize: "14px", fontWeight: 500 }}>
                        Promo Code
                    </label>
                    <Paper
                        component="form"
                        sx={{
                            p: "2px 4px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #E5E5E8",
                            height: 40,
                            marginTop: "10px",
                        }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                                placeholder="Search... "
                                inputProps={{ "aria-label": "search" }}
                                size="small"
                                name="trackingNumber"
                        />
                            <IconButton
                                color="primary"
                                sx={{ p: "10px" }}
                                aria-label="directions"
                            >
                                <Typography variant="body1" fontWeight="bold">
                                Generate
                                </Typography>
                            </IconButton>
                    </Paper>
                </Box>
                        </>
                    )
                }
                <Box sx={{ paddingX: "20px", paddingTop: "20px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Funds can be used for</Typography>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel value="shopping" control={<Radio />} label="Shopping" />
                            <FormControlLabel value="shipping" control={<Radio />} label="Shipping" />
                            <FormControlLabel value="Global" control={<Radio />} label="Global" />
                        </RadioGroup>
                    </FormControl>
                </Box>
                <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Expiry Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            onChange={(newValue) =>
                                console.log(newValue)
                            }
                            renderInput={(params) => (
                                <TextField {...params} name="endDate" />
                            )}
                            sx={{ 
                                width: "100%",
                            }}
                        />
                    </LocalizationProvider>
                </Box>
                <Box
                sx={{
                    paddingX: "20px",
                }}
                >
                <FormControlLabel
                    label="Never Expired"
                    control={
                    <Checkbox
                        size="small"
                        onChange={(event) => console.log(event.target.checked)}
                    />
                    }
                />
                </Box>
                {
                    activeCard === "Referral Campaign" && (
                        <Box sx={{ marginX: "20px", paddingTop: "10px", backgroundColor: "rgba(229, 229, 232, 1)" }} >
                            <Box>
                                <Typography sx={{ fontSize: "16px", marginLeft: "16px", fontWeight: 700 }}>Referral Bonus</Typography>
                            </Box>
                            <Box sx={{ marginTop: "10px" }}>
                                <Box sx={{ marginLeft: "16px", display: "flex", alignItems: "center" }}>
                                    <Typography>You get</Typography>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        sx={{ width: "20%", marginX: "5px" }}
                                        InputProps={{
                                        startAdornment: <InputAdornment>%</InputAdornment>,
                                        }}
                                    />
                                    <Typography>for the next</Typography>
                                    <FormControl sx={{ marginX: "5px", minWidth: 120 }}>
                                        <Select defaultValue="" size="small">
                                            <MenuItem value="">
                                                <em>Select</em>
                                            </MenuItem>
                                            <MenuItem value={"1st shipment ONLY"}>1st shipment ONLY</MenuItem>
                                            <MenuItem value={"Next 5 shipment within 12 months"}>Next 5 shipment within 12 months</MenuItem>
                                            <MenuItem value={"Next 10 shipment within 6 months"}>Next 10 shipment within 6 months</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box sx={{ marginLeft: "16px", display: "flex", alignItems: "center", marginTop: "10px" }}>
                                    <Typography>with a</Typography>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        sx={{ width: "60px", marginX: "5px" }}
                                            InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        }}
                                    />
                                    <Typography>maximum per shipping</Typography>
                                </Box>
                            </Box>
                        </Box>
                    )
                }
                <Box sx={{ marginX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Public Note</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </Box>
                <Box sx={{ marginX: "20px", paddingTop: "20px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Internal Note</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        multiline
                        rows={5}
                    />
                </Box>
                <Box sx={{ marginX: "20px", paddingTop: "10px", paddingBottom: "20px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Applied by</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                        <img src={people} alt="people" width={24} height={24} />
                        <Typography sx={{ marginLeft: "10px" }}>Arlene McCoy</Typography>
                    </Box>
                </Box>
            </SimpleBar>
            <Box
                sx={{
                    position: "absolute",
                    bottom: 10,
                    right: 20,
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                    backgroundColor: "#481AA3",
                    color: "#fff",
                    border: "1px solid #5E17EB",
                    boxShadow: "none",
                    marginBottom: "10px",
                    width: "190px",
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                    "&:hover": {
                        outline: "none",
                        color: "#fff",
                        backgroundColor: "#481AA3", // Remove border color on focus
                    },
                    }}
                >
                    Add funds to wallet
                </Button>
            </Box>
        </Box>
    </Drawer>
  )
}

export default AddFundDrawer